// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-menu::part(backdrop) {
  background-color: rgba(255, 0, 255, 0.5);
}

ion-menu::part(container) {
  border-radius: 0 20px 20px 0;
  box-shadow: 4px 0px 16px rgba(255, 0, 255, 0.18);
  background: linear-gradient(45deg, #085078 10%, #85d8ce 90%);
}

ion-menu ion-content {
  --padding-top: 20px;
  --padding-bottom: 20px;
  --background: transparent;
}

/* Remove background transitions for switching themes */
ion-menu ion-item {
  --transition: none;
  --background: transparent;
}

ion-item.selected {
  --color: var(--ion-color-primary);
}

/*
 * Material Design Menu
*/
ion-menu.md ion-list {
  padding: 20px 0;
}

ion-menu.md ion-list-header {
  padding-left: 18px;
  padding-right: 18px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  font-weight: 450;
}

ion-menu.md ion-item {
  --padding-start: 18px;
  margin-right: 10px;
  border-radius: 0 50px 50px 0;
  font-weight: 500;
}

ion-menu.md ion-item.selected {
  --background: rgba(var(--ion-color-primary-rgb), 0.14);
}

ion-menu.md ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}

ion-menu.md ion-list-header,
ion-menu.md ion-item ion-icon {
  color: var(--ion-color-step-650, #5f6368);
}

ion-menu.md ion-list:not(:last-of-type) {
  border-bottom: 1px solid var(--ion-color-step-150, #d7d8da);
}

/*
 * iOS Menu
*/
ion-menu.ios ion-list-header {
  padding-left: 16px;
  padding-right: 16px;
  margin-bottom: 8px;
}

ion-menu.ios ion-list {
  padding: 20px 0 0;
}

ion-menu.ios ion-item {
  --padding-start: 16px;
  --min-height: 50px;
}

ion-menu.ios ion-item ion-icon {
  font-size: 24px;
  color: #73849a;
}

ion-menu.ios ion-item.selected ion-icon {
  color: var(--ion-color-primary);
}

#background {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  overflow: visible !important;
  background: linear-gradient(45deg, #085078 10%, #85d8ce 90%);
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,wCAAA;AACF;;AAEA;EACE,4BAAA;EAEA,gDAAA;EAKA,4DAAA;AAAF;;AAGA;EACE,mBAAA;EACA,sBAAA;EACA,yBAAA;AAAF;;AAIA,uDAAA;AACA;EACE,kBAAA;EACA,yBAAA;AADF;;AAIA;EACE,iCAAA;AADF;;AAIA;;CAAA;AAGA;EACE,eAAA;AADF;;AAIA;EACE,kBAAA;EACA,mBAAA;EAEA,yBAAA;EACA,qBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,qBAAA;EAEA,kBAAA;EAEA,4BAAA;EAEA,gBAAA;AALF;;AAQA;EACE,sDAAA;AALF;;AAQA;EACE,+BAAA;AALF;;AAQA;;EAEE,yCAAA;AALF;;AAQA;EACE,2DAAA;AALF;;AAQA;;CAAA;AAGA;EACE,kBAAA;EACA,mBAAA;EAEA,kBAAA;AANF;;AASA;EACE,iBAAA;AANF;;AASA;EACE,qBAAA;EACA,kBAAA;AANF;;AASA;EACE,eAAA;EACA,cAAA;AANF;;AASA;EACE,+BAAA;AANF;;AASA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EAGA,4BAAA;EAUA,4DAAA;EACA,UAAA;AAbF","sourcesContent":["ion-menu::part(backdrop) {\n  background-color: rgba(255, 0, 255, 0.5);\n}\n\nion-menu::part(container) {\n  border-radius: 0 20px 20px 0;\n\n  box-shadow: 4px 0px 16px rgba(255, 0, 255, 0.18);\n  background: -webkit-linear-gradient(45deg, #085078 10%, #85d8ce 90%);\n  background: -moz-linear-gradient(45deg, #085078 10%, #85d8ce 90%);\n  background: -ms-linear-gradient(45deg, #085078 10%, #85d8ce 90%);\n  background: -o-linear-gradient(45deg, #085078 10%, #85d8ce 90%);\n  background: linear-gradient(45deg, #085078 10%, #85d8ce 90%);\n}\n\nion-menu ion-content {\n  --padding-top: 20px;\n  --padding-bottom: 20px;\n  --background: transparent;\n  // --background: var(--ion-item-background, var(--ion-background-color, #fff));\n}\n\n/* Remove background transitions for switching themes */\nion-menu ion-item {\n  --transition: none;\n  --background: transparent;\n}\n\nion-item.selected {\n  --color: var(--ion-color-primary);\n}\n\n/*\n * Material Design Menu\n*/\nion-menu.md ion-list {\n  padding: 20px 0;\n}\n\nion-menu.md ion-list-header {\n  padding-left: 18px;\n  padding-right: 18px;\n\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  font-weight: 450;\n}\n\nion-menu.md ion-item {\n  --padding-start: 18px;\n\n  margin-right: 10px;\n\n  border-radius: 0 50px 50px 0;\n\n  font-weight: 500;\n}\n\nion-menu.md ion-item.selected {\n  --background: rgba(var(--ion-color-primary-rgb), 0.14);\n}\n\nion-menu.md ion-item.selected ion-icon {\n  color: var(--ion-color-primary);\n}\n\nion-menu.md ion-list-header,\nion-menu.md ion-item ion-icon {\n  color: var(--ion-color-step-650, #5f6368);\n}\n\nion-menu.md ion-list:not(:last-of-type) {\n  border-bottom: 1px solid var(--ion-color-step-150, #d7d8da);\n}\n\n/*\n * iOS Menu\n*/\nion-menu.ios ion-list-header {\n  padding-left: 16px;\n  padding-right: 16px;\n\n  margin-bottom: 8px;\n}\n\nion-menu.ios ion-list {\n  padding: 20px 0 0;\n}\n\nion-menu.ios ion-item {\n  --padding-start: 16px;\n  --min-height: 50px;\n}\n\nion-menu.ios ion-item ion-icon {\n  font-size: 24px;\n  color: #73849a;\n}\n\nion-menu.ios ion-item.selected ion-icon {\n  color: var(--ion-color-primary);\n}\n\n#background {\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  //background-color: #75e5f7d0;\n  //background: url('../../../assets/img/header-bg.jpg');\n  overflow: visible !important;\n  // background: -webkit-linear-gradient(45deg, #085078 10%, #85d8ce 90%);\n  // background: -moz-linear-gradient(45deg, #085078 10%, #85d8ce 90%);\n  // background: -ms-linear-gradient(45deg, #085078 10%, #85d8ce 90%);\n  // background: -o-linear-gradient(45deg, #085078 10%, #85d8ce 90%);\n  // background: linear-gradient(45deg, #085078 10%, #85d8ce 90%);\n  background: -webkit-linear-gradient(45deg, #085078 10%, #85d8ce 90%);\n  background: -moz-linear-gradient(45deg, #085078 10%, #85d8ce 90%);\n  background: -ms-linear-gradient(45deg, #085078 10%, #85d8ce 90%);\n  background: -o-linear-gradient(45deg, #085078 10%, #85d8ce 90%);\n  background: linear-gradient(45deg, #085078 10%, #85d8ce 90%);\n  z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
